'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var rlp = require('rlp-encoding');

var ms = require('ms');

var Buffer = require('safe-buffer').Buffer;

var _require2 = require('../util');

var int2buffer = _require2.int2buffer,
    buffer2int = _require2.buffer2int,
    assertEq = _require2.assertEq;

var Peer = require('../rlpx/peer');

var createDebugLogger = require('debug');

var debug = createDebugLogger('devp2p:eth');
var MESSAGE_CODES = {
  // eth62
  STATUS: 0x00,
  NEW_BLOCK_HASHES: 0x01,
  TX: 0x02,
  GET_BLOCK_HEADERS: 0x03,
  BLOCK_HEADERS: 0x04,
  GET_BLOCK_BODIES: 0x05,
  BLOCK_BODIES: 0x06,
  NEW_BLOCK: 0x07,
  // eth63
  GET_NODE_DATA: 0x0d,
  NODE_DATA: 0x0e,
  GET_RECEIPTS: 0x0f,
  RECEIPTS: 0x10
};

var ETH =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(ETH, _EventEmitter);

  function ETH(version, peer, send) {
    var _this;

    _classCallCheck(this, ETH);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ETH).call(this));
    _this._version = version;
    _this._peer = peer;
    _this._send = send;
    _this._status = null;
    _this._peerStatus = null;
    _this._statusTimeoutId = setTimeout(function () {
      _this._peer.disconnect(Peer.DISCONNECT_REASONS.TIMEOUT);
    }, ms('5s'));
    return _this;
  }

  _createClass(ETH, [{
    key: "_handleMessage",
    value: function _handleMessage(code, data) {
      var payload = rlp.decode(data);

      if (code !== MESSAGE_CODES.STATUS) {
        debug("Received ".concat(this.getMsgPrefix(code), " message from ").concat(this._peer._socket.remoteAddress, ":").concat(this._peer._socket.remotePort, ": ").concat(data.toString('hex')));
      }

      switch (code) {
        case MESSAGE_CODES.STATUS:
          assertEq(this._peerStatus, null, 'Uncontrolled status message');
          this._peerStatus = payload;
          debug("Received ".concat(this.getMsgPrefix(code), " message from ").concat(this._peer._socket.remoteAddress, ":").concat(this._peer._socket.remotePort, ": : ").concat(this._getStatusString(this._peerStatus)));

          this._handleStatus();

          break;

        case MESSAGE_CODES.NEW_BLOCK_HASHES:
        case MESSAGE_CODES.TX:
        case MESSAGE_CODES.GET_BLOCK_HEADERS:
        case MESSAGE_CODES.BLOCK_HEADERS:
        case MESSAGE_CODES.GET_BLOCK_BODIES:
        case MESSAGE_CODES.BLOCK_BODIES:
        case MESSAGE_CODES.NEW_BLOCK:
          if (this._version >= ETH.eth62.version) break;
          return;

        case MESSAGE_CODES.GET_NODE_DATA:
        case MESSAGE_CODES.NODE_DATA:
        case MESSAGE_CODES.GET_RECEIPTS:
        case MESSAGE_CODES.RECEIPTS:
          if (this._version >= ETH.eth63.version) break;
          return;

        default:
          return;
      }

      this.emit('message', code, payload);
    }
  }, {
    key: "_handleStatus",
    value: function _handleStatus() {
      if (this._status === null || this._peerStatus === null) return;
      clearTimeout(this._statusTimeoutId);
      assertEq(this._status[0], this._peerStatus[0], 'Protocol version mismatch');
      assertEq(this._status[1], this._peerStatus[1], 'NetworkId mismatch');
      assertEq(this._status[4], this._peerStatus[4], 'Genesis block mismatch');
      this.emit('status', {
        networkId: this._peerStatus[1],
        td: Buffer.from(this._peerStatus[2]),
        bestHash: Buffer.from(this._peerStatus[3]),
        genesisHash: Buffer.from(this._peerStatus[4])
      });
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return this._version;
    }
  }, {
    key: "_getStatusString",
    value: function _getStatusString(status) {
      var sStr = "[V:".concat(buffer2int(status[0]), ", NID:").concat(buffer2int(status[1]), ", TD:").concat(buffer2int(status[2]));
      sStr += ", BestH:".concat(status[3].toString('hex'), ", GenH:").concat(status[4].toString('hex'), "]");
      return sStr;
    }
  }, {
    key: "sendStatus",
    value: function sendStatus(status) {
      if (this._status !== null) return;
      this._status = [int2buffer(this._version), int2buffer(status.networkId), status.td, status.bestHash, status.genesisHash];
      debug("Send STATUS message to ".concat(this._peer._socket.remoteAddress, ":").concat(this._peer._socket.remotePort, " (eth").concat(this._version, "): ").concat(this._getStatusString(this._status)));

      this._send(MESSAGE_CODES.STATUS, rlp.encode(this._status));

      this._handleStatus();
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(code, payload) {
      debug("Send ".concat(this.getMsgPrefix(code), " message to ").concat(this._peer._socket.remoteAddress, ":").concat(this._peer._socket.remotePort, ": ").concat(rlp.encode(payload).toString('hex')));

      switch (code) {
        case MESSAGE_CODES.STATUS:
          throw new Error('Please send status message through .sendStatus');

        case MESSAGE_CODES.NEW_BLOCK_HASHES:
        case MESSAGE_CODES.TX:
        case MESSAGE_CODES.GET_BLOCK_HEADERS:
        case MESSAGE_CODES.BLOCK_HEADERS:
        case MESSAGE_CODES.GET_BLOCK_BODIES:
        case MESSAGE_CODES.BLOCK_BODIES:
        case MESSAGE_CODES.NEW_BLOCK:
          if (this._version >= ETH.eth62.version) break;
          throw new Error("Code ".concat(code, " not allowed with version ").concat(this._version));

        case MESSAGE_CODES.GET_NODE_DATA:
        case MESSAGE_CODES.NODE_DATA:
        case MESSAGE_CODES.GET_RECEIPTS:
        case MESSAGE_CODES.RECEIPTS:
          if (this._version >= ETH.eth63.version) break;
          throw new Error("Code ".concat(code, " not allowed with version ").concat(this._version));

        default:
          throw new Error("Unknown code ".concat(code));
      }

      this._send(code, rlp.encode(payload));
    }
  }, {
    key: "getMsgPrefix",
    value: function getMsgPrefix(msgCode) {
      return Object.keys(MESSAGE_CODES).find(function (key) {
        return MESSAGE_CODES[key] === msgCode;
      });
    }
  }]);

  return ETH;
}(EventEmitter);

ETH.eth62 = {
  name: 'eth',
  version: 62,
  length: 8,
  constructor: ETH
};
ETH.eth63 = {
  name: 'eth',
  version: 63,
  length: 17,
  constructor: ETH
};
ETH.MESSAGE_CODES = MESSAGE_CODES;
module.exports = ETH;